export default "__VITE_ASSET__n_HQ$nMR__"